export default __webpack_public_path__ + "static/media/13.356386c8.svg";